// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uPj1uG3D2BAVWY-VLlEw1w\\=\\= h2{margin-bottom:100px}", "",{"version":3,"sources":["webpack://./src/views/cabinet/utils/components/History/History.module.scss"],"names":[],"mappings":"AACE,+BACE,mBAAA","sourcesContent":[".component{\n  & h2{\n    margin-bottom: 100px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"component": "uPj1uG3D2BAVWY-VLlEw1w=="
};
export default ___CSS_LOADER_EXPORT___;
